import { render, staticRenderFns } from "./businessUnitsFilesTabNew.vue?vue&type=template&id=d2d14118&scoped=true&"
import script from "./businessUnitsFilesTabNew.vue?vue&type=script&lang=js&"
export * from "./businessUnitsFilesTabNew.vue?vue&type=script&lang=js&"
import style0 from "./businessUnitsFilesTabNew.vue?vue&type=style&index=0&id=d2d14118&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d14118",
  null
  
)

export default component.exports